import { apiClient } from "../apiClient";
import { BACKEND_ENDPOINTS } from "../apiEndpoints";

export const getAllPlans = () =>
  apiClient.get(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.GET_ALL_PLANS}`,
  );

export const getPlanDetails = (id) =>
  apiClient.get(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.GET_PLAN_BY_ID}/${id}`,
  );

export const activateFreePlan = ({ userId, selectedPlan }) =>
  apiClient.post(
    `${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.ACTIVATE_FREE_PLAN}`,
    {
      userId,
      selectedPlan,
    },
    { headers: { "Content-Type": "application/json" } },
  );
